import React from "react";
import { Box, Flex, Image } from "rebass/styled-components";
import { MdVolumeUp, MdVolumeOff } from "react-icons/md";
import { space, color } from "styled-system";
import styled from "styled-components";
import { HiOutlineStar } from "react-icons/hi";
import { MdBrush } from "react-icons/md";
import { TGameLogoProps, TWithStudioIcon } from "./@types";
import { useHistory } from "react-router-dom";
import { ESupportedGames } from "../../@types";
import cs2SVG from "../../Assets/GameLogos/cs2.svg";
import csgoSVG from "../../Assets/GameLogos/csgo.svg";
import dotaSVG from "../../Assets/GameLogos/dota.svg";
import leagueSVG from "../../Assets/GameLogos/league.svg";
import fortniteSVG from "../../Assets/GameLogos/fortnite.svg";
import ow2SVG from "../../Assets/GameLogos/ow2.svg";
/*  Our Typings */

/*  Our LOCAL component imports */

/*  Our GLOBAL component imports */

//Not sure this is considered an icon, but its usually small enough to be one imo
function Callout(props: any) {
  return (
    <Box variant={props.variant ? props.variant : "callout"}>
      {props.children}
    </Box>
  );
}

const StyledUnmuted = styled(MdVolumeUp).attrs((props: any) => ({
  ...props,
}))((props) => props.styles, space, color);

export const UnMutedIcon = (props: any) => {
  return <StyledUnmuted {...props} />;
};

UnMutedIcon.defaultProps = {
  size: 24,
};

const StyledMuted = styled(MdVolumeOff).attrs((props) => ({
  ...props,
}))((props: any) => props.styles, space, color);

export const MutedIcon = (props: any) => {
  return <StyledMuted {...props} />;
};

MutedIcon.defaultProps = {
  size: 24,
};

export const SubscriptionsIcon = styled(HiOutlineStar).attrs((props: any) => ({
  ...props,
}))((props) => props.styles, space, color);

const Wrapper = styled(Flex)`
  max-height: 29px;

  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

const AllstarStudioIcon = styled<any>(Box)`
  display: flex;
  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    margin-right: ${(props: any) => (props.$shrinkMobile ? "0" : "5px")};
  }
`;

export const WithStudio = ({ to, mt, $shrinkMobile }: TWithStudioIcon) => {
  const history = useHistory();
  return (
    <Wrapper
      variant="studio"
      mt={mt ? mt : 0}
      onClick={() => {
        history.push(`${to ? to : `/studio/intro`}`);
      }}
    >
      <AllstarStudioIcon
        $shrinkMobile={$shrinkMobile}
        size="16px"
        as={MdBrush}
      />
    </Wrapper>
  );
};

export const ClipQualityIcon = ({
  size = 24,
  ...props
}: {
  size?: number;
  [key: string]: any;
}) => {
  const s = size;
  const rectW = s * 0.85;
  const rectH = s * 0.6;
  const rx = s * 0.08;
  const rectX = (s - rectW) / 2 - s * 0.04;
  const rectY = (s - rectH) / 2 + s * 0.08;
  const playX = rectX + rectW * 0.38;
  const playY = rectY + rectH * 0.28;
  const playSize = rectH * 0.44;
  const gearCx = rectX + rectW * 0.92;
  const gearCy = rectY + rectH * 0.08;
  const gr = s * 0.16;

  return (
    <svg
      width={s}
      height={s}
      viewBox={`0 0 ${s} ${s}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={rectX}
        y={rectY}
        width={rectW}
        height={rectH}
        rx={rx}
        fill="currentColor"
        opacity={0.15}
        stroke="currentColor"
        strokeWidth={s * 0.06}
      />
      <polygon
        points={`${playX},${playY} ${playX},${playY + playSize} ${
          playX + playSize * 0.85
        },${playY + playSize / 2}`}
        fill="currentColor"
      />
      <circle
        cx={gearCx}
        cy={gearCy}
        r={gr}
        fill="currentColor"
        opacity={0.9}
      />
      <circle
        cx={gearCx}
        cy={gearCy}
        r={gr * 0.45}
        fill="none"
        stroke="var(--gear-hole, #192832)"
        strokeWidth={s * 0.04}
      />
      {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => {
        const rad = (angle * Math.PI) / 180;
        const x1 = gearCx + Math.cos(rad) * gr * 0.7;
        const y1 = gearCy + Math.sin(rad) * gr * 0.7;
        const x2 = gearCx + Math.cos(rad) * gr * 1.05;
        const y2 = gearCy + Math.sin(rad) * gr * 1.05;
        return (
          <line
            key={angle}
            x1={x1}
            y1={y1}
            x2={x2}
            y2={y2}
            stroke="currentColor"
            strokeWidth={s * 0.06}
            strokeLinecap="round"
          />
        );
      })}
    </svg>
  );
};

export function GameLogos({ type, size, styles }: TGameLogoProps) {
  const defaultStyles = { marginRight: "8px" };
  styles = { ...defaultStyles, ...styles };
  switch (type) {
    case ESupportedGames.CS2:
      return <Image src={cs2SVG} size={size} {...styles} />;
    case ESupportedGames.CSGO:
      return <Image src={csgoSVG} size={size} {...styles} />;
    case ESupportedGames.DOTA2:
      return <Image src={dotaSVG} size={size} {...styles} />;
    case ESupportedGames.FORTNITE:
      return <Image src={fortniteSVG} size={size} {...styles} />;
    case ESupportedGames.LOL:
      return <Image src={leagueSVG} size={size} {...styles} />;
    case ESupportedGames.OW2:
      return <Image src={ow2SVG} size={size} {...styles} />;
    default:
      return <Image src={leagueSVG} size={size} {...styles} />;
  }
}
